import UpdateProfileActionBase from './update_profile_action_base';

export default class UpdateEmailAddress extends UpdateProfileActionBase {
  _update(profile, { index, original, primary }) {
    if (original) {
      profile.updateEmailAddress({ index, original, primary });
    } else {
      profile.deleteEmailAddress(index);
    }

    return { emails: profile.emails.map(email => email.toJs()) };
  }

  _getValidationErrors({ index, original }) {
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_profile/update_email_address.js